import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import {TeamappProvider} from "../../providers/teamapp";
import { Settings } from '../../settings';

/**
 * Generated class for the ContactPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-contact',
  templateUrl: 'contact.html',
})
export class ContactPage {

  contactForm: FormGroup;

  title: string = 'Kontaktanfrage';

  name: string;
  company: string;
  phone: string;
  email: string;
  receiver: string = '-1';
  callback: number = 0;
  message: string;
  policy: any;
  topics: any = [];

  showReceiver: boolean = Settings.receiverShow;
  titleReceiver: string = Settings.receiverTitle;
  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, public teamappProvider: TeamappProvider, public alertCtrl: AlertController) {

    let get_title = this.navParams.get("title");

    if(get_title) {
        this.title = get_title;
    }

    if(Settings.receiverShow ==true) {
        this.contactForm = this.formBuilder.group({
            name: ['', Validators.required],
            company: [''],
            phone: [''],
            email: [''],
            receiver: [''],
            callback: ['0'],
            message: ['', Validators.required],
            policy: [false, Validators.required]
        });
    }  else {
        this.contactForm = this.formBuilder.group({
            name: ['', Validators.required],
            company: [''],
            phone: [''],
            email: [''],
            callback: ['0'],
            message: ['', Validators.required],
            policy: [false, Validators.required]
        });
    }


    this.teamappProvider.http_request('action=get_topics', 'contact', false, true).then(data => {
        this.topics = data;
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContactPage');
  }

  ifPhoneValid() {
      if(this.callback == 1) {
          if(this.phone) {
              if(this.phone.length > 0) {
                  return true;
              }
              return false;
          }
      }
      return true;
  }

  submitContact() {
    this.teamappProvider.http_request('action=request_contact&contact_name='+this.name+'&contact_company='+this.company+'&contact_phone='+this.phone+'&contact_email='+this.email+'&contact_title='+this.title+'&contact_message='+this.message+'&contact_receiver='+this.receiver+'&contact_callback='+this.callback, 'contact', false, true).then(data => {

        console.log(data);
      const alert = this.alertCtrl.create({
          title: 'Erfolgreich!',
          subTitle: 'Die Kontaktanfrage wurde eingereicht und wird schnellstmöglich bearbeitet!',
          buttons: ['OK']
      });
      alert.present();
      this.navCtrl.pop();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts